export const getPhoneHref = (phone: string) => `tel:+45${phone.replaceAll(" ", "")}`;
